import React, { useState } from 'react';
import ModalComponent from '@components/Modal/ModalComponent';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { Card, CardBody } from '@components/card/card';
import { useTranslation } from 'react-i18next';
import AddAccountingPeriod from './AddAccountingPeriod';
import useGetGlPeriodsList from '@hooks/Finance/GlPeriods/useGetGlPeriodsList';
import { Link } from 'react-router-dom';
import { type PeriodsModels } from '@store/Finance/Periods/PeriodsModels';
import UpdateAccountingPeriod from './UpdateAccountingPeriod';
import Loading from '@components/Shared/Loader/Loading';
import NtxTable from '@components/DataTable/NtxTable';
import ClosingAccountingPeriod from './ClosingAccountingPeriod';
import { Can } from '@Permisstions/Can';

interface Props {
  customProp?: 'Inv' | 'Ap' | 'Ar' | 'Fleet' | 'Su' | 'Pur' | 'FA';
}

// مكون مشترك لكل الموديولات
const Index = ({ customProp }: Props) => {
  //

  const [Show, setShow] = useState(false);
  const { t, i18n } = useTranslation();
  const [dataById, setDataById] = useState<PeriodsModels>(); // for sent as props to Update component PeriodsModels

  const { PeriodsList, loading, error } = useGetGlPeriodsList();

  const columns = [
    { title: t('Name'), key: 'Name' },
    { title: t('FiscalYear'), key: 'year' },
    { title: t('Start'), key: 'start' },
    { title: t('End'), key: 'end' },
    { title: t('Status'), key: 'status' },
    { title: t(''), key: 'action', className: 'text-end' }
  ];

  const tableData = PeriodsList?.filter(f => f.periodYear !== null)?.map(item => {
    let rowClass;

    return {
      Name: i18n.language === 'ar' ? item.name2 : item.name,
      year: PeriodsList?.find(f => f.id === item.periodYear)?.name,
      start: item.startDate.toString(),
      end: item.endDate.toString(),
      status: <div className='align-middle'>{item.activeFlag === true ? 'مفتوحة' : 'مفلقة'}</div>,

      action: (
        <>
          <button
            type='button'
            className='btn btn-sm btn-outline-theme me-2'
            data-bs-toggle='modal'
            data-bs-target='#modalEditAccountingPeriod'
            onClick={() => setDataById(item)}
            hidden={!!customProp}
          >
            <i className='far fa-lg fa-fw mx-2 fa-edit'></i>
            {t('Button.Edit')}
          </button>
          <Can permission={['PURCloseAccountingPeriod']}>
            <button
              type='button'
              className='btn btn-sm btn-outline-theme'
              data-bs-toggle='modal'
              data-bs-target='#modalCloseAccountingPeriod'
              onClick={() => setDataById(item)}
            >
              <i className='fas fa-lg fa-fw mx-2 fa-lock'></i>
              {t('ClosePeriod')}
            </button>
          </Can>
        </>
      ),

      rowClass // استخدم rowClass هنا
    };
  });

  const titleModal = () => {
    return (
      <div className=''>
        {t('CloseAccountingPeriod')}
        {'  '}
        <span className='text-theme'>
          {`(${i18n.language === 'en' ? dataById?.name : dataById?.name2})`}
          {'  '}
          {`من ${dataById?.startDate}    إلى   ${dataById?.endDate}`}
        </span>
      </div>
    );
  };

  //____________________________
  const BcrumbList = [
    {
      name: 'Home',
      link: ':moduleHome'
    },
    {
      name: 'AccountingPeriods',
      link: null
    }
  ];

  return (
    <div>
      <div className='d-flex align-items-center'>
        <Breadcrumb BreadcrumbList={BcrumbList} PageName='AccountingPeriods' />

        <div className='ms-auto'>
          <Link
            to=''
            className='btn me-1 btn-theme'
            data-bs-toggle='modal'
            data-bs-target='#modalAddAccountingPeriod'
            onClick={() => setShow(true)}
            hidden={!!customProp}
          >
            <i className='fa fa-plus-circle fa-fw me-1'></i>
            {t('AddAccountingPeriod')}
          </Link>
        </div>
      </div>

      <Card>
        <Loading loading={loading} error={error}>
          <CardBody>
            <NtxTable
              data={tableData || []}
              columns={columns}
              dataPerPage={10}
              theadClass=''
              tableClass='table text-nowrap table-hover '
              enableSearch
              showRecordsSelector
            />
          </CardBody>
        </Loading>
      </Card>

      <ModalComponent title={t('AddAccountingPeriod')} id='modalAddAccountingPeriod' size='lg'>
        {Show && <AddAccountingPeriod />}
      </ModalComponent>

      <ModalComponent title={t('EditAccountingPeriod')} id='modalEditAccountingPeriod' size='lg'>
        {dataById && <UpdateAccountingPeriod DataById={dataById} />}
      </ModalComponent>
      <ModalComponent title={titleModal()} id='modalCloseAccountingPeriod' size='lg'>
        {dataById && <ClosingAccountingPeriod periodId={dataById?.id} customProp={customProp} />}
      </ModalComponent>
    </div>
  );
};

export default Index;
